export class User {
  public GMIN: string;
  public FirstName: string;
  public LastName: string;
  public Email: string;
  public ModuleId: any[];
  isActive: boolean = true;
}

export class Group {
  public Name: string;
  public Description: string;
  public ModuleId: any[];
}

export class Plant {
  public Name: string;
  public Abbreviation: string;
  public IsActive: boolean;
}

export class Module {
  public Id: string;
  public Name: string;
}

export class Program {
  public Id: string;
  public ProgramCode: string;
  public GlobalRegionId: string;
  public modelYearId: string;
  public IsActive: boolean;
}

export class GlobalRegion {
  public Description: string;
  public BackgroundColor: string;
  public RegionImage: string;
  public Id: string;

}

export class Zone {
  public Id: string;
  public Description: string;
  public IsActive: boolean;
  public Suffix: string;
}

export class SubZone {
  public Id: string;
  public Description: string;
  // public IsActive: boolean;
  // public Suffix: string;
}

export class System {
  public Id: string;
  public ProgramId: string;
  public SubZoneTitleId: string;
  public ModelYearId: string;
  public EgmContactId: string;
  public SystemSourceHourId: string;
  public SystemEstimationLevelId: string;
  public ConstructionHours: string;
  public IntegrationHours: string;
  public DesignDate: Date;
  public DockDate: Date;
  public DateTemplateId: string;

}

export class Center {
  public Description: string;
  public Id: string;
  public IsActive: boolean;
}

export class TntSystem {
  public Description: string;
  public CenterId: string;
  public Id: string;
  public IsActive: boolean;
}

export class Application {
  public TntSystemId: string;
  public Description: string;
  public IsActive: boolean;
}


export class TntToolType {
  public Description: string;
  public ApplicationId: string;
  public Id: string;
  public IsActive: boolean;
}

export class ArchiveTool {
  public Id: string;
  public ToolNumber: string;
  public ToolDescription: string;
  public OwnerGmin: boolean;
  public ArchivedDate: Date;
}

export class PlantProgram {
  public PlantName: string;
  public PlantId: string;
  public ProgramId: string;
  public PlantProgramDescription: string;
  public IsActive: boolean;
  public Id: string;
}

export class ProgramStyle {
  public ProgramStyleDescripton: string;
  public Id: string;
}

export class ModelYear {
  public Year: number;
  public Id: string;
}

export class Tool {
  public Id: string;
  public SystemId: number;
  public ToolTypeId: any;
  public ToolDescriptionId: any;
  public ToolDescription: string;
  public LegacyToolDescription: string;
  public AdditionInfo: string;
  public ToolNumber: string;
  public PlantOccuranceId: any;
  public PlantOccurance: string;
  public DesignHandedness: string;
  public LeftCount: number;
  public RightCount: number;
  public SingleCount: number;
  public MakeFurnish: string;
  public AssignJobNumber: boolean;
  public AssignToolNumber: boolean;
  public AssignLocationNumber: boolean;
  public TotalHours: number;
  public DesignEndDate: Date;
  public DockDate: Date;
  public Pcbom: any;
  public IsIntegration: boolean;
  public WireDesign: any;
  public Type: string;
  public CellParallelProcessId: any;
  public SystemLayout: any;
  public Name: string;
  public IsCancelled: boolean;
  public CellNumber: any;
  public StationNumber: any;
  public ToolDetail: ToolDetail;
  public ParentId: any;
  public ControlPanelDescriptionId: any;
  public ControlPanelDescription: any;
  public ControlPanelName: any;
  public SystemLayoutToolId: any;
  public ObjectId: any;
  public JobNumber: any;
  public ConstructionHours: any;
  public IntegrationHours: any;
  public ActualDesignEndDate: Date;
  public ActualDockDate: Date;
  public LocationNumber: any;
  public EstimateDollars: any;
  public ResourceLevel: any;
}

export class WorkflowInboxModel {
  public System: any;
  public Program: any;
  public Description: any;
  public ProcessLocation: any;
  public Actions: any;
}

export class ToolDetail {
  public ToolNumber: any;
  public ConstructionHours: any;
  public IntegrationHours: any;
  public PcBom: any;
  public IsIntegration: boolean;
  public WireDesign: any;
  public IsCancelled: boolean;
  public DesignEndDate: Date;
  public DockDate: Date;
  public IsActive: boolean;
  public ToolId: number;
  public ParentId: number;
}

export class Contact {
  public GMIN: string;
  public FirstName: string;
  public LastName: string;
  public Email: string;
  public IsActive: boolean;
}

export class Project {
  public ProjectNumber: string;
  public ProjectDescription: string;
  public PrimaryShopYear: number;
  public ContactId: string;
  public Email: string;
  public BIWLaborAggregate: number;
  public BIWLaborRate: number;
  public BIWMatlAggregate: number;
  public OutsideLaborRate: number;
  public OutsideMatlAggreate: number;
  public MechDesignRate: number;
  public CCRWDescRate: number;
  public Active: boolean;
}

export class Kit {
  public Id: string;
  public SystemId: string;
  public KitDescriptionId: number;
  public Description: string;
  public LeftCount: number;
  public RightCount: number;
  public SingleCount: number;
  public KitNumber: string;
  public TotalHours: number;
  public DesignEndDate: Date;
  public DockDate: Date;
  public Pcbom: any;
  public Integration: boolean;
  public WireDesign: any;
  public Cancelled: boolean;
  public ToolId: any;
  public SystemLayoutToolId: any;
  public JobNumber: any;
}

export class SubZoneTitle {
  public MajorAreaId: string;
  public ZoneId: string;
  public SubZoneId: string;
  public TitleId: string;
  public BodySectionId: string;
  public Id: string;
  public CreatedDate: string;
  public CreatedBy: string;
  public ModifiedDate: string;
  public ModifiedBy: string;
  public CenterId: string;
  public IsActive: boolean;
}
export class Title {
  public LidNumber: number;
  public Description: string;
  public CenterDescription: string;
  public Id: string;
  public CreatedDate: any;
  public CreatedBy: string;
  public ModifiedDate: any;
  public ModifiedBy: string;

}


export class ControlPanel {
  public Id: string;
  public SystemLayoutToolId: string;
  public ParentId: string;
  public ControlPanelDescriptionId: string;
  public VendorId: string;
  public Quantity: string;
  public ReqDate: string;
  public ActualReqDate: string;
  public WdToolRowId: string;
  public ObjectId: string;
  public CreatedDate: string;
  public CreatedBy: string;
  public ModifiedDate: string;
  public ModifiedBy: string;
}

export class ControlPanelDesc {
  public Name: string;
  public Description: string;
  public Status: boolean;
  public AdditionalInfo: string;
  public Id: string;
  public CreatedDate: Date;
  public CreatedBy: string;
  public ModifiedDate: Date;
  public ModifiedBy: Date;
}

export class KitDesc {
  public Name: string;
  public Status: boolean;
  public AdditionalInfo: string;
  public Id: string;
  public CreatedDate: string;
  public CreatedBy: string;
  public ModifiedDate: string;
  public ModifiedBy: string;
}

export class FurnishedEquip {
  public Id: string;
  public Name: string;
  public Description: string;
  public ToolTypeId: string;
  public CreatedDate: string;
  public CreatedBy: string;
  public ModifiedDate: string;
  public ModifiedBy: string;
  public IsActive: boolean;
  public AdditionalInfo: string;
}

export class ToolDesc {
  public Id: string;
  public Name: string;
  public Description: string;
  public ToolTypeId: string;
  public CreatedDate: string;
  public CreatedBy: string;
  public ModifiedDate: string;
  public ModifiedBy: string;
  public IsActive: boolean;
  public AdditionalInfo: string;
}



export class WeldGun {
  public Id: string;
  public Name: string;
  public Description: string;
  public ToolTypeId: string;
  public CreatedDate: string;
  public CreatedBy: string;
  public ModifiedDate: string;
  public ModifiedBy: string;
  public IsActive: boolean;
  public AdditionalInfo: string;
}

export class ToolOwner {
  public Ownername: string;
  public ToolNumber: string;
  public ToolDescription: string;
  public OwnerGmin: string;
  public FromOwnerGmin: string;
  public ToOwnerGmin: string;
  public ModuleTypeId: string;
}






